<template>
    <modal-component
      :active="active"
      @cancel="close"
      @hdlOnClick="updateStatus"
      textSave="Editar"
      :titleModal="`Editar ${item.name}`"
      :disabled="loading"
      :loader="loading"
      widthModal="width: 90%"
    >
      <div v-show="!showHtmlModal" class="has-text-confirmation editor-container">
        <div class="editor" ref="quillEditor"></div>
      </div>
      <div v-if="showHtmlModal" class="html-modal">
        <div class="buttons">
          <button class="button is-small" @click="saveHtmlContent">Ocultar editor html</button>
        </div>
        <textarea v-model="htmlContent" class="html-textarea"></textarea>
      </div>
    </modal-component>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mixins from '../../../mixins/formats'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import HtmlEditButton from 'quill-html-edit-button'

export default {
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  mixins: [mixins],
  props: {
    item: {
      type: Object
    },
    active: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      detault: () => {}
    },
    reload: {
      type: Function,
      detault: () => {}
    }
  },
  data () {
    return {
      loading: false,
      quill: null,
      htmlContent: null,
      showHtmlModal: false
    }
  },
  mounted () {
    this.initializeQuill()
  },
  methods: {
    ...mapActions(['updateCmsContent']),
    async updateStatus () {
      this.loading = true
      const htmlContent = this.showHtmlModal ? this.htmlContent : this.quill.root.innerHTML
      const response = await this.updateCmsContent({ contentId: this.item.id, content: htmlContent })
      if (response.success) {
        await this.reload()
        this.close()
      }
      this.loading = false
    },
    openHtmlModal () {
      this.htmlContent = this.quill.root.innerHTML
      this.showHtmlModal = true
    },
    initializeQuill () {
      setTimeout(() => {
        if (Quill && HtmlEditButton) {
          Quill.register('modules/htmlEditButton', HtmlEditButton)
        }
        if (!this.$refs?.quillEditor) {
          return
        }
        if (this.quill) {
          return // Ya existe, no vuelvas a crearlo
        }
        this.quill = new Quill(this.$refs.quillEditor, {
          theme: 'snow',
          placeholder: 'Escribe tu aquí...',
          modules: {
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                ['link', 'image'],
                [{ header: 1 }, { header: 2 }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ script: 'sub' }, { script: 'super' }],
                [{ indent: '-1' }, { indent: '+1' }],
                [{ size: ['small', false, 'large', 'huge'] }],
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ color: [] }, { background: [] }],
                [{ font: [] }],
                [{ align: [] }],
                ['clean'],
                ['htmlButton'] // 👈 Aquí pones el botón personalizado
              ],
              handlers: {
                htmlButton: () => {
                  this.openHtmlModal()
                }
              }
            }
          }
        })
        if (this.item?.content) {
          this.quill.clipboard.dangerouslyPasteHTML(this.item.content)
        }
        this.quill.getModule('toolbar')
        const button = document.querySelector('.ql-htmlButton')
        if (button) {
          button.innerHTML = '<i class="fas fa-code"></i>' // Puedes poner tu icono o texto
        }
      }, 100)
    },
    saveHtmlContent () {
      if (this.quill && this.htmlContent !== null) {
        this.quill.clipboard.dangerouslyPasteHTML(this.htmlContent)
      }
      this.showHtmlModal = false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany
    })
  }
}
</script>
